"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PEEKING_MULTIPLIER = exports.NEGATIVE_MULTIPLIER = exports.LARGE_VIEWPORT_MARGIN = exports.ITEMS_PER_VIEWPORT_MD = exports.ITEMS_PER_VIEWPORT_LG_XL = exports.HERO_POSITION_OFFSET = exports.GAP_BETWEEN_ITEMS = exports.DEFAULT_VIEWPORT_MARGIN = exports.DEFAULT_POSITION_OFFSET = exports.ACTIVE_INDEX_OFFSET_MULTIPLIER = void 0;
const ITEMS_PER_VIEWPORT_MD = exports.ITEMS_PER_VIEWPORT_MD = 2;
const ITEMS_PER_VIEWPORT_LG_XL = exports.ITEMS_PER_VIEWPORT_LG_XL = 3;
const GAP_BETWEEN_ITEMS = exports.GAP_BETWEEN_ITEMS = 16;
const HERO_POSITION_OFFSET = exports.HERO_POSITION_OFFSET = 20;
const DEFAULT_POSITION_OFFSET = exports.DEFAULT_POSITION_OFFSET = 0;
const LARGE_VIEWPORT_MARGIN = exports.LARGE_VIEWPORT_MARGIN = 40;
const DEFAULT_VIEWPORT_MARGIN = exports.DEFAULT_VIEWPORT_MARGIN = 10;
const PEEKING_MULTIPLIER = exports.PEEKING_MULTIPLIER = 2;
const ACTIVE_INDEX_OFFSET_MULTIPLIER = exports.ACTIVE_INDEX_OFFSET_MULTIPLIER = 1;
const NEGATIVE_MULTIPLIER = exports.NEGATIVE_MULTIPLIER = -1;